module.exports = __webpack_public_path__ + "7ce3245038ac2d4bc464753e271b1ef0.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-light.woff
// module id = 74
// module chunks = 0